import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { Remark } from './remarks.model';
import { DialogChild } from '../../dialogs/dialog-child';
import { UserService } from '../../user.service';
import { PermissionItem } from '../../shared/permissionitem.model';

@Component({
  selector: 'file360-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss']
})
export class RemarksComponent extends DialogChild implements OnInit {

  form: FormGroup;
  /** Current remarks */
  oldRemarks: Remark | undefined;
  /** New remark field */
  newRemark: Remark | undefined;

  /** List of permission ids - initialization need to make Permission available to the html */
  PermissionItem = PermissionItem;

  /**
   * RemarksComponent constructor
   * @param userService the logged on user information
   */
  constructor(private userService: UserService) {
    super();

    this.form = new FormGroup({
      'oldremarks': new FormControl(),
      'newremark': new FormControl('', Validators.required)
    });
  }

  /** Get old remarks field */
  get oldremarksField(): FormControl {
    return this.form.get('oldremarks') as FormControl;
  }

  /** Get new remarks field */
  get newremarkField(): FormControl {
    return this.form.get('newremark') as FormControl;
  }

  /** 
    * Componenet initialization
  */
  ngOnInit() {
    this.oldRemarks = new Remark(this.data as Remark);
    this.oldremarksField.setValue(this.oldRemarks.Content, { emitEvent: false });

    this.newRemark = new Remark(this.oldRemarks);
    this.newRemark.Content = "";
    this.data = this.newRemark;

    this.raiseIsValid(this.form.valid);

    this.newremarkField.valueChanges.subscribe(value => {
      if (this.newRemark != undefined) {
        this.newRemark.Content = value;
      }
    });

    this.form.valueChanges.subscribe(() => this.raiseIsValid(this.form.valid));
  }

  /** 
    * Determine if the old remarks should be dispalyed
  */
  public showOldRemarks(): boolean {
    // if there are old remarks dont show the text field
    return (this.oldRemarks != undefined && this.oldRemarks.Content.length != 0);
  }

  /** 
    * Determine if the new remarks should be dispalyed
  */
  public showNewRemarks(): boolean {
    return this.hasPermission(PermissionItem.RemarksAppend) && (this.oldRemarks != undefined && this.oldRemarks.AllowAdds);
  }

  /** 
    * Determine if the user has permission to a function
  */
  public hasPermission(perm: PermissionItem): boolean {
    return this.userService.currentUser.getPermission(perm);
  }

  /**
   * Get the min and max rows for the new remarks field
   */
  public getMinRows(): number {
    return this.showOldRemarks() ? 5 : 13;
  }
  public getMaxRows(): number {
    return this.showOldRemarks() ? 5 : 13;
  }
}
